<div class="container my-4">
	<ul ngbNav class="nav-tabs">
		<li ngbNavItem role="presentation">
			<h3><i class="bi bi-building-fill-gear me-2 text-primary"></i>Organisaatiot</h3>
		</li>
		<li ngbNavItem class="ms-auto pe-2">
			<form class="form-inline">
				<input
					class="form-control mr-sm-2"
					type="search"
					placeholder="Hae"
					aria-label="Hae"
					[(ngModel)]="searchText"
					(input)="filterOrganizations()"
					name="searchText"
				/>
			</form>
		</li>
		<li ngbNavItem>
			<div class="col-auto d-flex gap-2">
				<button class="btn btn-primary" (click)="openAddOrgModal()">
					<i class="bi bi-building-fill-add me-1"></i>Lisää organisaatio
				</button>
			</div>
		</li>
	</ul>

	@if (isLoading) {
		<div
			class="d-flex justify-content-center align-items-center"
			style="min-height: 400px"
		>
			<div class="text-center">
				<div
					class="spinner-border text-primary"
					role="status"
					style="width: 3rem; height: 3rem"
				>
					<span class="visually-hidden">Ladataan...</span>
				</div>
				<p class="mt-3 text-muted">Ladataan organisaatioita...</p>
			</div>
		</div>
	} @else {
		<!-- Error message -->
		@if (hasError) {
			<div class="row">
				<div class="col-12">
					<div class="alert alert-danger" role="alert">
						<i class="bi bi-exclamation-triangle me-2"></i>
						{{ errorMessage }}
					</div>
				</div>
			</div>
		}

		<!-- No content message -->
		@if (organizations.length === 0 && !hasError) {
			<div class="row">
				<div class="col-12 text-center py-5">
					<div class="alert alert-info" role="alert">
						<i class="bi bi-info-circle me-2"></i>
						Ei organisaatioita löytynyt. Luo ensimmäinen
						organisaatio yllä olevalla painikkeella.
					</div>
				</div>
			</div>
		}

		<!-- Organization list -->
		@if (organizations.length > 0 && !hasError) {
			<div class="row mt-4">
				<div class="col-12">
					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<th
										scope="col"
										class="sortable-header"
										(click)="sortOrganizations('name')"
									>
										Organisaation nimi
										<i
											class="ms-1"
											[ngClass]="getSortIcon('name')"
										></i>
									</th>
									<th
										scope="col"
										class="sortable-header"
										(click)="sortOrganizations('userCount')"
									>
										Käyttäjät
										<i
											class="ms-1"
											[ngClass]="getSortIcon('userCount')"
										></i>
									</th>
									<th scope="col" class="text-end"></th>
								</tr>
							</thead>
							<tbody>
								@for (org of filteredOrganizations; track org) {
									<tr [@fadeInImmediately]>
										<td>
											<span class="fw-medium">{{ org.name }}</span>
										</td>
										<td>
											<span class="text-muted"
												>{{
													CountOrganizationUsers(
														org.id
													) || 0
												}}
												käyttäjää</span
											>
										</td>
										<td class="text-end">
											<button
												type="button"
												class="btn btn-outline-secondary btn-sm me-1"
												(click)="openEditOrgModal(org)"
												title="Muokkaa organisaatiota"
											>
												<i class="bi bi-pencil"></i>
											</button>
											<button
												type="button"
												class="btn btn-outline-danger btn-sm"
												(click)="
													deleteOrganization(org)
												"
												title="Poista organisaatio"
											>
												<i class="bi bi-trash"></i>
											</button>
										</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		}
	}
</div>

<!-- Add Organization Modal -->
<ng-template #addOrgModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Lisää uusi organisaatio</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss('Cross click')"
			[disabled]="isCreatingOrganization"
		></button>
	</div>
	<div class="modal-body">
		<form>
			<div class="mb-3">
				<label for="orgName" class="form-label"
					>Organisaation nimi</label
				>
				<input
					type="text"
					class="form-control"
					id="orgName"
					[(ngModel)]="newOrganization.name"
					name="orgName"
					placeholder="Anna organisaation nimi"
					required
				/>
			</div>
		</form>

		<ngb-alert
			type="danger"
			*ngIf="errors.length > 0"
			[dismissible]="false"
		>
			<strong>Organisaatiota ei voitu lisätä</strong>
			<ul>
				<li *ngFor="let error of errors">{{ error }}</li>
			</ul>
		</ngb-alert>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.close('Close click')"
			[disabled]="isCreatingOrganization"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-primary"
			(click)="addOrganization()"
			[disabled]="!newOrganization.name.trim() || isCreatingOrganization"
		>
			<span
				*ngIf="isCreatingOrganization"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i
				*ngIf="!isCreatingOrganization"
				class="bi bi-check-lg me-1"
			></i>
			Tallenna
		</button>
	</div>
</ng-template>

<!-- Edit Organization Modal -->
<ng-template #editOrgModal let-modal>
	<div class="modal-header" *ngIf="editingOrganization">
		<h4 class="modal-title">Muokkaa organisaatiota</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss('Cross click')"
			[disabled]="isUpdatingOrganization"
		></button>
	</div>
	<div class="modal-body" *ngIf="editingOrganization">
		<form>
			<div class="mb-3">
				<label for="editOrgName" class="form-label"
					>Organisaation nimi</label
				>
				<input
					type="text"
					class="form-control"
					id="editOrgName"
					[(ngModel)]="editingOrganization.name"
					name="editOrgName"
					placeholder="Anna organisaation nimi"
					required
				/>
			</div>
		</form>
	</div>
	<div class="modal-footer" *ngIf="editingOrganization">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.close('Close click')"
			[disabled]="isUpdatingOrganization"
		>
			Peruuta
		</button>
		<button
			type="button"
			class="btn btn-primary"
			(click)="updateOrganization()"
			[disabled]="!editingOrganization.name.trim() || isUpdatingOrganization"
		>
			<span
				*ngIf="isUpdatingOrganization"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i
				*ngIf="!isUpdatingOrganization"
				class="bi bi-check-lg me-1"
			></i>
			Tallenna muutokset
		</button>
	</div>
</ng-template>
